<template>
  <div class="col-12" id="navBar">

  <ul class="nav  flex-column" >
  <li class="nav-item dateTimeText">
    <a class="nav-link ">{{timestamp | formatDate}}</a>
  </li>
  <hr>
  <li class="nav-item">
    <a class="nav-link" v-bind:class="{active: getCurrentSidebarElement==='Home'}" @click="sideBarElementClick('Home')" aria-current="page" >Acceuil</a>
  </li><li class="nav-item">
    <a class="nav-link" v-bind:class="{active: getCurrentSidebarElement==='ItWomen'}" @click="sideBarElementClick('ItWomen')" aria-current="page" >IT Women</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" v-bind:class="{active: getCurrentSidebarElement==='outdoor'}" @click="sideBarElementClick('About')"  >A propos</a>
  </li>
</ul>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import {mapGetters} from 'vuex'
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(value).locale("fr").format("DD MMMM YYYY, HH:mm");
  }
});
export default {
  name: "Sidebar",
  data() {
    return {
      timestamp: "",
      isHomeActive: false,
      isItWomenActive: false,
      isOutdoorActive: false,
    };
  },
  methods: {
    getNow() {
      const today = new Date();
      this.timestamp = today;
    },
    sideBarElementClick(value){
      this.$store.commit("menus/setCurrentSidebarElement", value);
    },
    activeHome(){this.isHomeActive = !this.isHomeActive},
    activeItWomen(){this.isItWomenActive = !this.isItWomenActive},
    activeOutdoor(){this.isOutdoorActive = !this.isOutdoorActive},
  },
  computed: {
    ...mapGetters("menus",["getCurrentSidebarElement"])
  },
  created() {
    this.getNow()
    setInterval(this.getNow, 60000);
  },
};
</script>
<style src="./sidebar.scss" lang="scss" scoped/>
